import React from 'react';

const CompanyProfile = () => {
    const TempData = JSON.parse(localStorage.getItem('tempOnboardingData'));
    let company_name = TempData && TempData.company_name;
    let company_phone = TempData && TempData.company_phone;
    let company_zip = TempData && TempData.company_zip;
    let company_address = TempData && TempData.company_address;
    let company_city = TempData && TempData.company_city;
    let company_state = TempData && TempData.company_state;
    let company_billing_id = TempData && TempData.company_billing_id;
    let company_billing_tax_id = TempData && TempData.company_billing_tax_id;
    let company_billing_npi = TempData && TempData.company_billing_npi;
    let company_billing_address = TempData && TempData.company_billing_address;
    let company_billing_address_2 = TempData && TempData.company_billing_address_2;
    let company_billing_city = TempData && TempData.company_billing_city;
    let company_billing_zip = TempData && TempData.company_billing_zip;
    let company_billing_state = TempData && TempData.company_billing_state;
    
    return (
        <div className="brd_tab_cntnt">
            <div className="brding_frm_ele">
                <span>Company Name</span>
                <input defaultValue={company_name}  id="company_name" type="text" placeholder="Company Name"/>
            </div> <br />
            <div className="brding_frm_ele">
                <span>Address</span>
                <input defaultValue={company_address}  id="company_address" type="text" placeholder="Address"/>
            </div> <br />
            

            {/* <div className="dual_element">
                <div className="brding_frm_ele __first_item">
                    <span>City</span>
                    <input type="text" placeholder="City" />
                </div>
                <div className="brding_frm_ele __last_item">
                    <span style={{ width: '5rem' }}>Zip Code</span>
                    <input type="text" placeholder="Zip Code" />
                </div>
            </div> <br /> */}
            <div className="brding_frm_ele">
                <span>City</span>
                <input defaultValue={company_city}  id="city" style={{ width: '25%' }} type="text" placeholder="City" />
            </div> <br />
            <div className="brding_frm_ele">
                <span>Zip Code</span>
                <input defaultValue={company_zip}  id="zip_code" style={{ width: '25%' }} type="text" placeholder="Zip Code" />
            </div> <br />
            <div className="brding_frm_ele">
                <span>State</span>
                <input defaultValue={company_state}  id="state" type="text" placeholder="State"/>
            </div> <br /> <br />

            <b>Company billing info</b>

            <div className="brding_frm_ele fx_margin">
                <span>Billing ID</span>
                <input defaultValue={company_billing_id}  id="billing_id" style={{width: '23%'}} type="text" placeholder="Billing ID" />
            </div> <br />
            <div className="brding_frm_ele">
                <span>Tax ID</span>
                <input defaultValue={company_billing_tax_id}  id="tax_id" style={{ width: '27%' }} type="text" placeholder="Tax ID" />
            </div> <br />
            <div className="brding_frm_ele">
                <span>Billing NPI</span>
                <input defaultValue={company_billing_npi}  id="billing_npi" style={{ width: '27%' }} type="text" placeholder="Billing NPI" />
            </div> <br />
            <div className="brding_frm_ele">
                <span>Billing Address 1</span>
                <input defaultValue={company_billing_address}  id="billing_address" type="text" placeholder="Billing Address" />
            </div> <br />
            <div className="brding_frm_ele">
                <span>Billing Address 2</span>
                <input defaultValue={company_billing_address_2}  id="billing_address_2" type="text" placeholder="Billing Address" />
            </div> <br />
            <div className="brding_frm_ele">
                <span>Phone</span>
                <input defaultValue={company_phone}  id="phone" type="text" placeholder="Phone" />
            </div> <br />
            <div className="brding_frm_ele">
                <span>City</span>
                <input defaultValue={company_billing_city}  id="billing_city" style={{ width: '27%' }} type="text" placeholder="City" />
            </div> <br />
            <div className="brding_frm_ele">
                <span>Zip Code</span>
                <input defaultValue={company_billing_zip}  id="billing_zip" style={{ width: '27%' }} type="text" placeholder="Zip Code" />
            </div> <br />
            <div className="brding_frm_ele">
                <span>State</span>
                <input defaultValue={company_billing_state}  id="billing_state" type="text" placeholder="State" />
            </div> <br /> <br />
        </div>
    )
};

export default CompanyProfile;


// WEBPACK FOOTER //
// ./src/app/setup_onboarding/comps/CompanyProfile.js